import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BaseURL } from "../../APIs/APIUrls";
import { GetAllPageBannerforWeb } from "../../APIs/APIHelperforWeb";
export default function PageTitle2({ setMetaTitle, setMetaDescription, setMetaKeywords, setMetaImage }) {
  const { pathname } = useLocation();
  const fallbackBanner = {
    pageName: "Latest News",
    image: "/images/page-title/page-title-1.jpg",
  };
  const [banner, setBanner] = useState(fallbackBanner);

  const normalizePath = (value = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "/";

    let pathValue = rawValue;
    try {
      if (/^https?:\/\//i.test(rawValue)) {
        pathValue = new URL(rawValue).pathname;
      }
    } catch (error) {
      pathValue = rawValue;
    }

    const withoutQueryOrHash = decodeURIComponent(pathValue)
      .split(/[?#]/)[0]
      .trim()
      .toLowerCase();
    if (!withoutQueryOrHash) return "/";

    const withLeadingSlash = withoutQueryOrHash.startsWith("/")
      ? withoutQueryOrHash
      : `/${withoutQueryOrHash}`;

    const compactSlashes = withLeadingSlash.replace(/\/+/g, "/");
    return compactSlashes.length > 1
      ? compactSlashes.replace(/\/+$/, "")
      : compactSlashes;
  };

  const getPageNameFromPath = (path) => {
    const cleanPath = normalizePath(path);
    const segment = cleanPath.split("/").filter(Boolean).pop() || "latest-news";
    return segment
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getBestBannerMatch = (rows, activePath) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const scoredMatches = rows
      .map((item) => {
        const bannerPath = normalizePath(item?.PageURL);
        if (!bannerPath || bannerPath === "/") {
          return null;
        }

        let score = 0;
        if (bannerPath === activePath) {
          score = 4;
        } else if (activePath.startsWith(`${bannerPath}/`)) {
          score = 3;
        } else if (bannerPath.startsWith(`${activePath}/`)) {
          score = 2;
        } else {
          const activeSlug = activePath.split("/").filter(Boolean).pop();
          const bannerSlug = bannerPath.split("/").filter(Boolean).pop();
          if (activeSlug && bannerSlug && activeSlug === bannerSlug) {
            score = 1;
          }
        }

        if (!score) return null;
        return { item, score, pathLength: bannerPath.length };
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score || b.pathLength - a.pathLength);

    return scoredMatches[0]?.item || null;
  };

  const resolveImageUrl = (imagePath = "") => {
    const value = String(imagePath || "").trim();
    if (!value) return "/images/page-title/page-title-1.jpg";
    if (/^https?:\/\//i.test(value) || value.startsWith("data:")) {
      return value;
    }
    const normalizedPath = value.startsWith("/") ? value : `/${value}`;
    return `${BaseURL.replace(/\/+$/, "")}${normalizedPath}`;
  };

  useEffect(() => {
    const fetchPageBanner = async () => {
      const rows = await GetAllPageBannerforWeb();
      const activePath = normalizePath(pathname);
      const matchedBanner = getBestBannerMatch(rows, activePath);
      const metaTitle = matchedBanner?.MetaTitle || `${getPageNameFromPath(activePath)} | AskMeRealty`;
      const metaDescription = matchedBanner?.MetaDescription || "AskMeRealty - Our Services include property buying, selling, renting, and property management. We provide comprehensive real estate solutions to meet your needs.";
      const metaKeywords = matchedBanner?.MetaKeyword || "Our Services, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions";
      const metaImage = matchedBanner?.Image ? BaseURL + matchedBanner.Image : "";

      if (matchedBanner) {
        setBanner({
          pageName: matchedBanner?.PageName || getPageNameFromPath(activePath),
          image: resolveImageUrl(matchedBanner?.Image),
           alttext: matchedBanner?.ImageAltText || getPageNameFromPath(activePath),
        });
        if (typeof setMetaTitle === "function") {
          setMetaTitle(matchedBanner?.MetaTitle || "Our Services || AskMeRealty - Real Estate Services");
        }
        if (typeof setMetaDescription === "function") {
          setMetaDescription(matchedBanner?.MetaDescription || "AskMeRealty - Our Services include property buying, selling, renting, and property management. We provide comprehensive real estate solutions to meet your needs.");
        }
        if (typeof setMetaKeywords === "function") {
          setMetaKeywords(matchedBanner?.MetaKeyword || "Our Services, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions");
        }
        if (typeof setMetaImage === "function") {
          setMetaImage(metaImage);
        }
      } else {
        setBanner({
          pageName: getPageNameFromPath(activePath),
          image: fallbackBanner.image,
          alttext: getPageNameFromPath(activePath),
        });
      }
    };

    fetchPageBanner();
  }, [pathname]);

  return (
    <section className="flat-title-page flat-title-page--image">
      <img
        className="flat-title-page__image"
        src={banner.image}
        alt={banner.alttext || banner.pageName}
      />
      <div className="container">
        <div className="breadcrumb-content">
          <ul className="breadcrumb">
            <li>
              <Link to={`/`} className="text-white">
                Home
              </Link>
            </li>
            <li className="text-white">/ Pages</li>
            <li className="text-white">/ {banner.pageName}</li>
          </ul>
          <h1 className="text-center text-white title">{banner.pageName}</h1>
        </div>
      </div>
    </section>
  );
}
